export enum Married {
	unmarried = "未婚（離死別も含む）",
	married = "既婚",
}
